import React from 'react';

import { Spinner } from 'react-bootstrap';

const Loader = ({ label }) => {
  return (
    <div className='loader d-flex align-items-center mt-5'>
      <Spinner animation='border' variant='primary' className='loader-spinner' style={{borderWidth: '2px'}} />
      <span>{label}</span>
    </div>
  );
};
export default Loader;
